import React from 'react';
// No need to import User type if only using placeholder activities for now
// import { User } from '../../services/userService'; 

interface ActivityTimelineProps {
    // Activities are currently passed as placeholders from parent
    activities: any[]; // Keep as any[] until real activity data structure is defined/fetched
}

// Placeholder icons (replace with FontAwesome or similar later)
const icons: { [key: string]: string } = {
    'chart-bar': '📊',
    'users': '👥',       // Font Awesome mapping might be different
    'code-branch': '🍴',
    'clock': '🕒',
    'history': '📜' // For empty state
};

const ActivityTimeline: React.FC<ActivityTimelineProps> = ({ activities }) => {
    const hasActivities = activities && activities.length > 0;

    return (
        <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white py-3">
                <h5 className="mb-0 fw-bold">Recent Activity</h5>
            </div>
            <div className="card-body p-4">
                {hasActivities ? (
                    <div className="position-relative"> {/* Keep relative for the line */}
                        {/* Vertical Timeline Line - Adjust left offset */}
                        <div 
                            className="position-absolute top-0 bottom-0 start-0"
                            style={{ width: '2px', backgroundColor: '#e9ecef', left: '24px' /* Approx center of a 50px icon */ }} 
                        />
                        
                        {activities.map((activity, index) => (
                            // mb-4 for spacing between items
                            <div key={activity.id} className="d-flex align-items-start mb-4"> {/* Use align-items-start if content heights vary */}
                                {/* Activity Icon - Now part of flex flow */}
                                <div 
                                    className={`rounded-circle bg-${activity.color} text-white p-2 d-flex align-items-center justify-content-center flex-shrink-0`}
                                    // Use fixed width/height and z-index to ensure it's above the line visually
                                    style={{ width: '50px', height: '50px', zIndex: 1 }}
                                >
                                    {/* TODO: Replace with actual icon component */}
                                    <span style={{ fontSize: '1.25rem' }}>{icons[activity.icon] || '❓'}</span>
                                </div>
                                
                                {/* Activity Content - Use Bootstrap margin start (ms-3) */}
                                <div className="ms-3 pt-1"> 
                                    <p className="mb-1">{activity.description}</p>
                                    <p className="text-muted small mb-0">
                                        {/* TODO: Replace with actual icon component */}
                                        <span className="me-1">{icons.clock}</span> {activity.time}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    // Empty State Content
                    <div className="text-center py-3">
                        <div className="mb-3">
                            {/* TODO: Replace with actual icon component */}
                            <span style={{ fontSize: '3rem' }} className="text-muted">{icons.history}</span>
                        </div>
                        <h6 className="mb-2">No recent activity</h6>
                        <p className="text-muted small mb-0">Your activity on DataNest will appear here</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActivityTimeline; 